import React, { useMemo, useState, useEffect } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useFormikContext } from 'formik'
import { getReferralsCatalog } from '../../../services/referralsServices'

type Props = {
  value: number | null
  onChange: (val: number | null) => void
  placeholder?: string
  minChars?: number
}

export function AutocompleteReferCatalogField({
  value,
  onChange,
  placeholder = '',
  minChars = 0,
}: Props) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [categories, setCategories] = useState<any[]>([])
  const { setFieldTouched, validateField } = useFormikContext<any>()

  // debounce
  const [debounced, setDebounced] = useState('')
  useEffect(() => {
    const id = setTimeout(() => setDebounced(query.trim()), 200)
    return () => clearTimeout(id)
  }, [query])

  useEffect(() => {
    const fetchData = async () => {
      const response = await getReferralsCatalog()
      setCategories(response?.results ?? [])
    }
    fetchData()
  }, [])

  const enableSearch = debounced.length >= minChars && debounced.length > 0

  const visible = useMemo(() => {
    if (!enableSearch) return categories.slice(0, 10)
    const q = debounced.toLowerCase()
    return categories
      .filter((c) => c.name.toLowerCase().includes(q))
      .slice(0, 10)
  }, [enableSearch, debounced, categories])

  const selectedId = value === null || value === undefined ? null : Number(value)

    const selectedCategory = useMemo(() => {
        if (selectedId === null) return null
        return categories.find((c) => Number(c.id) === selectedId) || null
    }, [selectedId, categories])


  const highlightMatch = (text: string, query: string) => {
    if (!query) return text
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
    return text.split(regex).map((part, i) =>
      regex.test(part) ? <strong key={i}>{part}</strong> : <span key={i}>{part}</span>
    )
  }

  const handleSelect = (id: number) => {
    onChange(id)
    setQuery('')
    setOpen(false)
    setFieldTouched('invitee_qualification', true, false)
  }

  const handleRemove = () => {
    onChange(null)
    setFieldTouched('invitee_qualification', true, false)
    validateField('invitee_qualification')
  }

  return (
    <div className="nb-language-autocomplete">
      <div className="nb-language-wrapper">
        {selectedCategory && (
          <div className="tap-add-experience-2-category-pill tap-add-experience-2-category-pill--selected">
            {/* <KTSVG path={toAbsoluteUrl('/media/svg/nobilis/teams_and_partner/category_icon.svg')} /> */}
            <span>{selectedCategory.name}</span>
            <div onClick={handleRemove}>
              <KTSVG path={toAbsoluteUrl('/media/svg/nobilis/remove.svg')} />
            </div>
          </div>
        )}

        {!selectedCategory && (
          <input
            className="tap-add-experience-input-category nb-language-input"
            placeholder={placeholder}
            value={query}
            disabled={!!selectedCategory}
            onChange={(e) => {
                setQuery(e.target.value)
                setOpen(true)
            }}
            onFocus={() => setOpen(true)}
            onBlur={() => setTimeout(() => setOpen(false), 120)}
            />
        )}
      </div>

      {open && visible.length > 0 && (
        <div className="nb-language-menu">
          {visible.map((item) => (
            <div
              key={item.id}
              className="nb-language-item"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(item.id)}
            >
              {highlightMatch(item.name, debounced)}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
